import { makeStyles } from '@material-ui/core/styles';

export const largeCircularLoaderStyle = { width: '100px', height: '100px' };

const useStyles = makeStyles(() => ({
  loader: {
    width: 'min-content',
  },
}));

export default useStyles;
